import React, { useEffect } from 'react';
import { config } from '../../config/env';

const Unauthorized = ({ error, redirectUrl }) => {
  useEffect(() => {
    // Immediately redirect to common auth login
    // No error message for session invalidation - silent redirect for better UX
    const loginUrl = redirectUrl || config.COMMON_AUTH_LOGIN_URL;

    // Ensure we're redirecting to login, not dashboard
    const finalUrl = loginUrl.includes('/dashboard')
      ? config.COMMON_AUTH_LOGIN_URL
      : loginUrl;

    // Silent redirect without error parameter
    window.location.href = finalUrl;
  }, [error, redirectUrl]);

  // Return null since we're redirecting immediately
  return null;
};

export default Unauthorized;
